import type {EmailAutomationRow, EmailAutomationStatus} from "./types";

export const PLACEHOLDER_DATA: EmailAutomationRow[] = [
  {
    key: "1",
    name: "Course purchase email",
    status: "Draft",
    trigger: "after-purchase",
    offerings: 0,
    sent: 0,
    delivered: 0,
  },
  {
    key: "2",
    name: "Lead magnet delivery",
    status: "Active",
    trigger: "after-purchase",
    offerings: 10,
    sent: 500,
    delivered: 425,
  },
  {
    key: "3",
    name: "Welcome sequence",
    status: "Active",
    trigger: "after-purchase",
    offerings: 2,
    sent: 70,
    delivered: 54,
  },
  {
    key: "4",
    name: "Engagement campaign",
    status: "Paused",
    trigger: "abandoned-purchase",
    offerings: 5,
    sent: 82,
    delivered: 52,
  },
  {
    key: "5",
    name: "Post purchase followup",
    status: "Paused",
    trigger: "after-purchase",
    offerings: 4,
    sent: 82,
    delivered: 76,
  },
];

export const statusTag: Record<EmailAutomationStatus, {color: string; border?: string}> =
  {
    Draft: {color: "purple"},
    Active: {color: "green"},
    Paused: {color: "default"},
  };

export const DEFAULT_BODY = `<p>Hi {Customer_name},</p><p><br></p><p>Thank you for purchasing {Offering_name}. I'm excited to have you on board and look forward to helping you on this journey.</p><p><br></p><p>To access your offering, simply click the button below.</p><p><br></p><p>If you have any questions or need any help, feel free to reach out to {Coach_email}.</p><p><br></p><p>Best,</p><p>{Coach_name}</p>`;

export const SHORT_CODES = [
  {code: "{Customer_name}", desc: "This will be replaced with your customer's name"},
  {code: "{Coach_name}", desc: "This will be replaced with your name"},
  {code: "{Coach_email}", desc: "This will be replaced with your email"},
  {code: "{Offering_name}", desc: "This will be replaced with your offering name"},
];

export const stripHtml = (html: string) => html.replace(/<[^>]*>/g, "").trim();
